import React from 'react';
import PlaceholderLogo from '../../../assets/placeholderLogo.png';
import JsonSchema from '../../../components/JsonSchema';
import resizeImage from '../../../utils/resizeImage';
import deconstructAddress from '../../../utils/deconstructAddress';
import profileUrl from '../../../utils/profileUrl';
import config from '../../../../src/client/config';
import useAggregateContacts from '../../../hooks/useAggregateContacts';

const { urlRoot } = config;

const LocalBusinessSchema = ({ data }) => {
  const {
    name,
    suburb: dataSuburb,
    state: dataState,
    hash,
    s3_logo: logo,
    slogan,
    main_contacts: mainContacts,
    additional_contacts: additionalContacts,
    servicing,
    location,
    locations,
  } = data || {};

  const aggregateContacts = useAggregateContacts([
    ...mainContacts,
    ...additionalContacts,
  ]);

  const { callNumbers } = aggregateContacts;

  let itemListElement = {
    '@context': 'http://schema.org',
    '@type': 'LocalBusiness',
    name,
  };

  if (callNumbers && !!callNumbers.length) {
    itemListElement = {
      ...itemListElement,
      telephone: callNumbers[0].info,
    };
  }

  itemListElement = {
    ...itemListElement,
    image: logo ? resizeImage(logo) : PlaceholderLogo,
  };

  if (name && dataSuburb && dataState && hash) {
    itemListElement = {
      ...itemListElement,
      url: `${urlRoot}${profileUrl({
        name,
        suburb: dataSuburb,
        state: dataState,
        hash,
      })}`,
    };
  }

  if (slogan) {
    itemListElement = {
      ...itemListElement,
      description: slogan,
    };
  }

  if (dataSuburb || dataState) {
    const locationAddress = location && deconstructAddress(locations[0]);
    if (!servicing && location) {
      itemListElement = {
        ...itemListElement,
        address: {
          '@type': 'PostalAddress',
          streetAddress: locationAddress.street || '',
          addressLocality: locationAddress.suburb || '',
          addressRegion: locationAddress.state || '',
          postalCode: locationAddress.postcode || '',
        },
      };
    } else {
      itemListElement = {
        ...itemListElement,
        address: {
          '@type': 'PostalAddress',
          addressLocality: dataSuburb || '',
          addressRegion: dataState || '',
        },
      };
    }
  }

  return <>{JsonSchema(itemListElement)}</>;
};

export default LocalBusinessSchema;
